var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEthizoPopups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_6491",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H17.5V17.5H0.5V0.5Z",
    fill: "#63B4FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_6491)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7924 11.4067L4.59183 9.05983L13.3197 5.26137C12.323 3.92281 10.9171 3.25342 9.10141 3.25342C7.55605 3.25342 6.24905 3.79627 5.18082 4.88258C4.11239 5.96869 3.57838 7.28662 3.57838 8.83573C3.57838 10.4862 4.10821 11.867 5.16807 12.9784C6.22772 14.0899 7.58135 14.6455 9.22811 14.6455C11.8712 14.6455 13.6955 13.1426 14.7003 10.1366L17.5 10.7807C15.8785 15.2602 13.1127 17.5 9.20281 17.5C6.84662 17.5 4.80698 16.6707 3.08431 15.012C1.36165 13.3532 0.5 11.3534 0.5 9.01272C0.5 6.6214 1.32757 4.6047 2.9829 2.96282C4.63803 1.32094 6.66931 0.5 9.07674 0.5C12.7249 0.5 15.4781 2.44582 17.3363 6.33747L5.7924 11.4067Z",
    fill: "#80B2B7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEthizoPopups);
export default __webpack_public_path__ + "static/media/ic-ethizo-popups.afaac26ce34948240ac4f61e207c6214.svg";
export { ForwardRef as ReactComponent };